import React from 'react';
import styled from 'styled-components';

import type { IDlsBlockViewProps } from '@/components/common';

import { HOUR_IN_PX, LINE_IN_PX } from '@/config/variables';
import { colors, otherColors } from '@/styles/colors';

interface IProps extends IDlsBlockViewProps {
  onMouseMove?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, offset: number) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const DlsBlockDayView = ({ week, dlsPosition, onMouseMove, onMouseLeave }: IProps): React.ReactElement => {
  if (!week.dst) return <></>;

  const dlsBlockDuration = Math.abs(week.dst.tzOffsetDiff) * HOUR_IN_PX;
  const dlsBlockPosition =
    (dlsPosition?.minutesFromMidnight ?? 0) - (week.dst.tzOffsetDiff < 0 ? 0 : dlsBlockDuration / 2);

  return (
    <Wrapper
      onMouseMove={event => onMouseMove && onMouseMove(event, dlsBlockPosition)}
      onMouseLeave={onMouseLeave}
      minutesFromMidnight={dlsBlockPosition}
      blockDuration={dlsBlockDuration}
    />
  );
};
export { DlsBlockDayView };

const Wrapper = styled.div<{
  minutesFromMidnight: number;
  blockDuration: number;
}>`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
  background-color: ${colors.red.c100};
  background-image: repeating-linear-gradient(
    180deg,
    ${otherColors.calendar.dlsDayHGrid},
    ${otherColors.calendar.dlsDayHGrid} ${LINE_IN_PX}px,
    transparent ${LINE_IN_PX}px,
    transparent ${HOUR_IN_PX}px
  );

  width: 100%;
  height: ${props => props.blockDuration}px;

  transform: translate3d(0, ${props => props.minutesFromMidnight}px, 0);

  & > span {
    font-weight: bold;
    padding: 3px;
    text-shadow: -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff, 2px 2px 0 #fff;
    line-height: 16px;
  }
`;
